// scripts/seedFirestore.jsx
import React from "react";
import {
  firestore,
  collection,
  doc,
  setDoc,
  getFirestore,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";

// Note: In a real application, you'd import your firebase config
// import { firebaseConfig } from '../firebase/config';

const SeedFirestoreData = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  // This would come from your config file in a real app
  const firebaseConfig = {
    apiKey: "AIzaSyBCZDrQOBi_SMmWIeCgkBOAvpNSzkD6h6A",
    authDomain: "skyholistics-1366c.firebaseapp.com",
    projectId: "skyholistics-1366c",
    storageBucket: "skyholistics-1366c.appspot.com",
    messagingSenderId: "299960912418",
    appId: "1:299960912418:web:3e31ce5e42ca2d52ef587b",
    measurementId: "G-61ED6NFTTE",
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  const seedDatabase = async () => {
    setIsLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      // 1. Seed Content Categories
      const contentCategoriesData = [
        {
          name: "10th English",
          identifier: "10th_eng",
          description: "Study materials for 10th Standard English Medium",
          active: true,
        },
        {
          name: "10th Kannada",
          identifier: "10th_kannada",
          description: "Study materials for 10th Standard Kannada Medium",
          active: true,
        },
        {
          name: "Navodaya",
          identifier: "navodaya",
          description: "Preparation materials for Navodaya entrance exam",
          active: true,
        },
        {
          name: "Morarji",
          identifier: "morarji",
          description: "Preparation materials for Morarji entrance exam",
          active: true,
        },
        {
          name: "NCERT",
          identifier: "ncert",
          description: "NCERT-based study materials",
          active: true,
        },
      ];

      for (const category of contentCategoriesData) {
        await setDoc(
          doc(db, "contentCategories", category.identifier),
          category
        );
        console.log(`Added category: ${category.name}`);
      }

      // 2. Seed Smart Contents
      const smartContentsData = [
        // 10th English - Academic Notes
        {
          title: "10th English - Science Notes",
          description:
            "Comprehensive notes covering all Science chapters for 10th Standard English Medium",
          category: "10th_eng",
          subCategory: "academic_notes",
          imageUrl:
            "https://images.unsplash.com/photo-1532094349884-543bc11b234d",
          pages: 45,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },
        {
          title: "10th English - Mathematics Notes",
          description: "Complete mathematics notes with formulas and examples",
          category: "10th_eng",
          subCategory: "academic_notes",
          imageUrl:
            "https://images.unsplash.com/photo-1509228468518-180dd4864904",
          pages: 52,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },

        // 10th English - SSLC Board Old Q.P.
        {
          title: "10th English - SSLC Board Papers 2023",
          description: "Previous year SSLC Board question papers from 2023",
          category: "10th_eng",
          subCategory: "sslc_board",
          imageUrl:
            "https://images.unsplash.com/photo-1588072432836-e10032774350",
          pages: 30,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },
        {
          title: "10th English - SSLC Board Papers 2022",
          description: "Previous year SSLC Board question papers from 2022",
          category: "10th_eng",
          subCategory: "sslc_board",
          imageUrl:
            "https://images.unsplash.com/photo-1434030216411-0b793f4b4173",
          pages: 28,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },

        // 10th English - Model Q.P.
        {
          title: "10th English - Model Question Paper Set 1",
          description:
            "Model question papers prepared by experts for 10th Standard",
          category: "10th_eng",
          subCategory: "model_qp",
          imageUrl:
            "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
          pages: 15,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },

        // 10th English - Textbook
        {
          title: "10th English - Science Textbook Summary",
          description:
            "Concise summary of the Science textbook with important points",
          category: "10th_eng",
          subCategory: "textbook",
          imageUrl:
            "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8",
          pages: 60,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },

        // 10th Kannada - Academic Notes
        {
          title: "10th Kannada - Science Notes",
          description: "Comprehensive Science notes in Kannada Medium",
          category: "10th_kannada",
          subCategory: "academic_notes",
          imageUrl:
            "https://images.unsplash.com/photo-1532094349884-543bc11b234d",
          pages: 48,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },

        // 10th Kannada - SSLC Board
        {
          title: "10th Kannada - SSLC Board Papers 2023",
          description: "Previous year SSLC Board question papers in Kannada",
          category: "10th_kannada",
          subCategory: "sslc_board",
          imageUrl:
            "https://images.unsplash.com/photo-1588072432836-e10032774350",
          pages: 32,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },

        // Navodaya - Notes
        {
          title: "Navodaya Entrance Exam Notes",
          description:
            "Comprehensive study notes for Navodaya entrance preparation",
          category: "navodaya",
          subCategory: "notes",
          imageUrl:
            "https://images.unsplash.com/photo-1522661067900-ab829854a57f",
          pages: 40,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },

        // Navodaya - Q.P.
        {
          title: "Navodaya Entrance Model Question Papers",
          description: "Model question papers for Navodaya entrance exam",
          category: "navodaya",
          subCategory: "model_qp",
          imageUrl:
            "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
          pages: 25,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },

        // Morarji - Notes
        {
          title: "Morarji Entrance Exam Study Guide",
          description: "Complete study guide for Morarji entrance examination",
          category: "morarji",
          subCategory: "notes",
          imageUrl:
            "https://images.unsplash.com/photo-1522661067900-ab829854a57f",
          pages: 38,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },

        // Morarji - Q.P.
        {
          title: "Morarji Entrance Mock Tests",
          description: "Mock tests and practice papers for Morarji entrance",
          category: "morarji",
          subCategory: "model_qp",
          imageUrl:
            "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
          pages: 22,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },

        // NCERT - Notes
        {
          title: "NCERT Mathematics Notes",
          description: "Study notes based on NCERT Mathematics textbooks",
          category: "ncert",
          subCategory: "notes",
          imageUrl:
            "https://images.unsplash.com/photo-1509228468518-180dd4864904",
          pages: 55,
          format: "PDF",
          updatedAt: new Date(),
          popular: true,
          downloadUrl: "#",
        },

        // NCERT - Q.P.
        {
          title: "NCERT Science Practice Questions",
          description: "Practice questions based on NCERT Science curriculum",
          category: "ncert",
          subCategory: "model_qp",
          imageUrl:
            "https://images.unsplash.com/photo-1532094349884-543bc11b234d",
          pages: 30,
          format: "PDF",
          updatedAt: new Date(),
          popular: false,
          downloadUrl: "#",
        },
      ];

      for (const content of smartContentsData) {
        const docRef = doc(collection(db, "smartContents"));
        await setDoc(docRef, content);
        console.log(`Added smart content: ${content.title}`);
      }

      // 3. Seed Test Series Programs
      const testSeriesProgramsData = [
        {
          id: "english",
          title: "10th Standard English Medium",
          tests: "12 Tests",
          description:
            "Comprehensive test series covering the entire English Medium Syllabus for 10th Standard",
          features: [
            "Full syllabus coverage",
            "Chapter-wise tests",
            "Model question papers",
            "Performance analysis",
            "Detailed solutions",
            "Doubt clearing sessions",
          ],
          price: "₹3,500",
          image: "https://images.unsplash.com/photo-1588072432836-e10032774350",
          popular: true,
          startDates: ["July 15, 2023", "August 1, 2023"],
        },
        {
          id: "kannada",
          title: "10th Standard Kannada Medium",
          tests: "12 Tests",
          description:
            "Comprehensive test series in Kannada Medium for 10th Standard students",
          features: [
            "Full syllabus coverage in Kannada",
            "Chapter-wise tests",
            "Model question papers",
            "Performance analysis",
            "Detailed solutions",
            "Doubt clearing sessions",
          ],
          price: "₹3,500",
          image: "https://images.unsplash.com/photo-1588072432836-e10032774350",
          popular: false,
          startDates: ["July 15, 2023", "August 1, 2023"],
        },
        {
          id: "ncert",
          title: "10th Standard NCERT (Maths + Science)",
          tests: "15 Tests",
          description:
            "Focused test series for NCERT Maths and Science for 10th Standard students",
          features: [
            "Comprehensive NCERT coverage",
            "Chapter-wise tests",
            "Topic-wise analysis",
            "Performance tracking",
            "Detailed solutions",
            "Doubt clearing sessions",
          ],
          price: "₹4,000",
          image: "https://images.unsplash.com/photo-1576334761529-e8d00379d4ce",
          popular: false,
          startDates: ["July 20, 2023", "August 10, 2023"],
        },
        {
          id: "navodaya",
          title: "Navodaya Entrance Test Series",
          tests: "10 Tests",
          description:
            "Specialized test series for Jawahar Navodaya Vidyalaya entrance preparation",
          features: [
            "Previous year questions",
            "Mock tests",
            "Section-wise practice",
            "Performance analysis",
            "Detailed solutions",
            "Expert guidance",
          ],
          price: "₹2,500",
          image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
          popular: true,
          startDates: ["January 15, 2023", "February 15, 2023"],
        },
        {
          id: "morarji",
          title: "Morarji Entrance Test Series",
          tests: "10 Tests",
          description:
            "Specialized test series for Morarji Desai Residential School entrance preparation",
          features: [
            "Previous year questions",
            "Mock tests",
            "Section-wise practice",
            "Performance analysis",
            "Detailed solutions",
            "Expert guidance",
          ],
          price: "₹2,500",
          image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
          popular: false,
          startDates: ["January 15, 2023", "February 15, 2023"],
        },
      ];

      for (const program of testSeriesProgramsData) {
        await setDoc(doc(db, "testSeriesPrograms", program.id), program);
        console.log(`Added test series program: ${program.title}`);
      }

      // 4. Seed Subject Tests
      const subjectTestsData = [
        {
          id: "maths",
          title: "Mathematics",
          chapters: [
            {
              id: "chapter1",
              title: "Chapter 1: Numbers and Operations",
              tests: 5,
            },
            {
              id: "chapter2",
              title: "Chapter 2: Algebra and Equations",
              tests: 4,
            },
            {
              id: "chapter3",
              title: "Chapter 3: Geometry and Measurements",
              tests: 3,
            },
          ],
        },
        {
          id: "science",
          title: "Science",
          chapters: [
            { id: "chapter1", title: "Chapter 1: Matter and Energy", tests: 5 },
            { id: "chapter2", title: "Chapter 2: Life Processes", tests: 4 },
            { id: "chapter3", title: "Chapter 3: Natural Resources", tests: 3 },
          ],
        },
        {
          id: "social",
          title: "Social Science",
          chapters: [
            {
              id: "chapter1",
              title: "Chapter 1: History - Modern India",
              tests: 5,
            },
            {
              id: "chapter2",
              title: "Chapter 2: Geography - Resources",
              tests: 4,
            },
            {
              id: "chapter3",
              title: "Chapter 3: Civics - Democracy",
              tests: 3,
            },
          ],
        },
      ];

      for (const subject of subjectTestsData) {
        await setDoc(doc(db, "subjectTests", subject.id), subject);
        console.log(`Added subject test: ${subject.title}`);
      }

      // 5. Seed Sample Tests
      const testsData = [];

      // Create sample tests for each chapter in each subject
      for (const subject of subjectTestsData) {
        for (const chapter of subject.chapters) {
          for (let i = 1; i <= chapter.tests; i++) {
            testsData.push({
              id: `${subject.id}_${chapter.id}_test${i}`,
              title: `Test ${i}: ${chapter.title}`,
              subjectId: subject.id,
              chapterId: chapter.id,
              duration: "30 minutes",
              questions: 20,
              marks: 40,
              difficulty: ["Easy", "Medium", "Hard"][
                Math.floor(Math.random() * 3)
              ],
              description: `This test covers important concepts from ${chapter.title}. It is designed to assess your understanding and problem-solving abilities.`,
              instructions: [
                "Read each question carefully before answering.",
                "Time management is crucial. Don't spend too much time on any one question.",
                "There is no negative marking for wrong answers.",
                "Make sure to attempt all questions for maximum score.",
              ],
              syllabus: [
                "Basic concepts and definitions",
                "Core formulas and their applications",
                "Problem-solving techniques",
                "Advanced applications",
              ],
            });
          }
        }
      }

      for (const test of testsData) {
        await setDoc(doc(db, "tests", test.id), test);
        console.log(`Added test: ${test.title}`);
      }

      // 6. Seed Testimonials
      const testimonialsData = [
        {
          id: "testimonial1",
          content:
            "The smart content provided by SKYSEP was instrumental in my exam preparation. The concise notes and question papers helped me revise effectively.",
          author: "Priya Verma",
          rank: "96% in 10th Standard, 2023",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
        },
        {
          id: "testimonial2",
          content:
            "What sets SKYSEP's study material apart is how they simplify complex topics. The question papers and notes especially helped me prepare thoroughly.",
          author: "Rahul Sharma",
          rank: "Selected for Navodaya, 2023",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
        },
        {
          id: "testimonial3",
          content:
            "The model question papers and SSLC board old question papers were extremely helpful. They gave me a good idea of what to expect in the exams.",
          author: "Amit Patel",
          rank: "98% in Science, 2023",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyBOAHtlqzaow5_rlz81tF3SwDxw4m5bYPzQ&s",
        },
        {
          id: "testimonial4",
          content:
            "The test series helped me score 95% in my exams. The detailed explanations after each test helped me understand concepts better and improved my accuracy.",
          author: "Deepa Reddy",
          rank: "10th Std Topper 2023",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5HVVqbKEfRB2KnjIkT9XmJfWcENcZObNPuQ&s",
        },
        {
          id: "testimonial5",
          content:
            "What sets this test series apart is the quality of questions and the comprehensive performance analysis. It helped me identify my weak areas and focus my preparation accordingly.",
          author: "Arjun Singh",
          rank: "Navodaya Selected 2023",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s",
        },
        {
          id: "testimonial6",
          content:
            "The chapter-wise tests and model papers were extremely helpful. The feedback from faculty members helped me improve my answering strategy.",
          author: "Neha Kumar",
          rank: "Morarji School Selected 2023",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyBOAHtlqzaow5_rlz81tF3SwDxw4m5bYPzQ&s",
        },
      ];

      for (const testimonial of testimonialsData) {
        await setDoc(doc(db, "testimonials", testimonial.id), testimonial);
        console.log(`Added testimonial from: ${testimonial.author}`);
      }

      setSuccessMessage("Successfully seeded the Firestore database!");
    } catch (error) {
      console.error("Error seeding database:", error);
      setErrorMessage(`Error seeding database: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Firestore Database Seeder</h1>

      <p className="mb-4 text-gray-700">
        This tool will populate your Firestore database with sample data for
        smart content, test series programs, subject tests, and testimonials.
        Click the button below to seed your database.
      </p>

      <button
        onClick={seedDatabase}
        disabled={isLoading}
        className={`px-4 py-2 rounded-md text-white font-medium ${
          isLoading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
        }`}
      >
        {isLoading ? "Seeding Database..." : "Seed Database"}
      </button>

      {successMessage && (
        <div className="mt-4 p-3 bg-green-100 text-green-700 rounded-md">
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
          {errorMessage}
        </div>
      )}

      <div className="mt-6">
        <h2 className="text-xl font-semibold mb-4">Seeding Details</h2>
        <div className="bg-gray-100 p-4 rounded-md">
          <p>This script will create:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>
              5 content categories (10th English, 10th Kannada, Navodaya,
              Morarji, NCERT)
            </li>
            <li>14 smart content items (notes, question papers, textbooks)</li>
            <li>5 test series programs</li>
            <li>
              3 subject tests (Mathematics, Science, Social Science) with
              chapters
            </li>
            <li>Sample tests for each chapter</li>
            <li>6 testimonials</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SeedFirestoreData;
